import React from 'react'
import "../styles/chat.css"
import { Outlet, useNavigate,useLocation} from 'react-router'
import { useState } from 'react'
import { Button, CircularProgress, IconButton, Link, Skeleton, useMediaQuery } from '@mui/material'
import { useEffect } from 'react'
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';
import MessageIcon from '@mui/icons-material/Message';
import { motion } from "framer-motion"
import { Circle, CircleOutlined } from '@mui/icons-material'
import { Input } from 'antd'

export default function Chat({latestMessage,handleLatestMessage,userData,ActiveShope,optimizer,handle_optimizer,online,unread}) {
  let [ShowAllShopes,HandleShowAllShopes]=useState(false)
  let [AllChats,GetAllChats]=useState([])
  let [LoadAllChats,GetLoadAllChats]=useState([])
  
  useEffect(()=>{
    GetLoadAllChats(true)
    axios.get(`${process.env.REACT_APP_URL}/api/chats/GetAllShopeChat/${ActiveShope}`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      GetAllChats(res.data)
      //console.log(res.data);
      GetLoadAllChats(false)
    })
    .catch(error=>{
      GetLoadAllChats(false)
    })

  },[optimizer,ActiveShope])

  const location = useLocation()
  const [routes,setRoutes]=useState(location.pathname.split("/"))
  const [nochat,handle_no_chat]=useState(!routes[2]||routes[2]?.length<1)
  let [showChat,handleShowChat]=useState(false)
  const matches = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    let newRoute=location.pathname.split("/")
    setRoutes(newRoute);
    handle_no_chat(!newRoute[2]||newRoute[2]?.length<1)
  }, [location.pathname,optimizer,ActiveShope,matches]);

  let sampleChat=[1,2,3,4]
  return (
    <div className={`chat ${matches&&"chat-minimized"}`}>
       <div className={`chat-left ${(!nochat&&matches)&&"hidden-chat-page"}`}>
          <div  className='chat-left-head'>
            <div><Button onClick={()=>HandleShowAllShopes(!ShowAllShopes)}>All  Shopes</Button></div>
            <h2>Chats</h2>
          </div>
            {ShowAllShopes&&<AllShopes online={online} handle_optimizer={handle_optimizer} optimizer={optimizer}
                             ActiveShope={ActiveShope} userData={userData} HandleShowAllShopes={HandleShowAllShopes}/>}
            <motion.div 
              initial={{ opacity: 0, x:-100 }}
              whileInView={{ opacity: 1,x:0}}
              transition={{ duration: 0.4 }}
              className='chat-left-allChat'>
               {
                LoadAllChats?
                  <>
                     {sampleChat.map((e,index)=>{
                        return <div key={index} style={{display:"flex",alignItems:"center",gap:"10px",marginTop:'10px',marginLeft:"20px"}}>
                        <div><Skeleton variant="circular" width={60} height={60} /></div>
                        <div>  <Skeleton animation="wave" height={50} width={matches?"200px":"100px"} /></div>
                    </div>
                     })}
                  </>
                  :
                 <>
                    {AllChats?.length===0&&<div style={{textAlign:"center",fontWeight:"700",marginTop:"20px"}}>No Chat</div>}
                    {AllChats.map((e,index)=>{

                      return <EachChat latestMessage={latestMessage} handleLatestMessage={handleLatestMessage} optimizer={optimizer} unread={unread} online={online} ActiveShope={ActiveShope} data={e} userData={userData}/>
                    })}
                 
                 </>
               }
              
            </motion.div>
       </div> 
       
       <div className={`chat-right ${(nochat&&matches)&&"hidden-chat-page"}`}>
          {(nochat&&!matches)?
            <div className='chat-right-nochat'> 
                No chat currently availeble
            </div>:
          <Outlet/>
          }

       </div>
    </div>
  )
}

const EachChat=({ActiveShope,data,userData,online,unread,optimizer,latestMessage,handleLatestMessage})=>{
   let getShope=data.shops?.filter(e=>{
    return e._id!==ActiveShope
   })
   let [unreadOfShope,handleUnreadOfShop]=useState(0)

   
  const location = useLocation()
  const [routes,setRoutes]=useState(location.pathname.split("/"))
   let[currentRoute,setCurrentRoute]=useState(routes[2])

   useEffect(() => {
    setRoutes(location.pathname.split("/"));
    setCurrentRoute(prevRoute => {
      return location.pathname.split("/")[2];
    });
  }, [location.pathname,optimizer,ActiveShope]);
  
  //let showUnread=online?.chat===data._id&&online?.unread&&

  useEffect(()=>{
  //console.log()
    axios.get(`${process.env.REACT_APP_URL}/api/chats/GetChatUnreadMessage?chatId=${data?._id}&&shopId=${getShope[0]?._id}`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      handleUnreadOfShop(res.data.unreadMessages)
      unread.handleFlagUnread(e=>[...e,res.data.unreadMessages])
      //console.log(res.data);
    })
    .catch(error=>{
      //console.log(error)
    })

  },[unread.controlUnread])
  
 
  //console.log(getShope[0],online,online?.unread);
  /////console.log(unreadOfShope,data.unreadMessages,ActiveShope);
  useEffect(()=>{
    let latestMessageForThatChatExist=latestMessage.filter(e=>{
      return e?.chat===data?.latestMessage?.chat
   })
   if(latestMessageForThatChatExist.length===0){
       handleLatestMessage(e=>[...e,data?.latestMessage]) 
   }
  },[data])
  let newLattestMessageExist=latestMessage.filter(e=>{
    return e?.chat?._id===data._id
  })
  let lattest=newLattestMessageExist[0]?.content?.length>15?`${newLattestMessageExist[0]?.content?.slice(0,15)}...`:newLattestMessageExist[0]?.content
  //console.log(latestMessage);

  return(
    <Link href={`/chat/${data._id}`}>
        <div className={`chat-left-allChat-each ${(currentRoute===data?._id)&&"chat-left-allChat-each-active"}`}>
            <div><img src={getShope[0]?.coverPic?.fileUrl||"/default-JB-FE-Shop_10.png"} width={30} height={30}/></div>
            <div  className='chat-left-allChat-each-right'>
              <div className='chat-left-allChat-each-right-title'>
                  <div  className='chat-left-allChat-each-right-shope_name' style={{color:!getShope[0]?.shope_name&&"red"}}>{getShope[0]?.shope_name||"Deleted Shop"}</div>
                  {unreadOfShope>0&&<div className='chat-left-allChat-each-right-unreadMessagesCount'>{unreadOfShope<=0?null:unreadOfShope}</div>}
                  {(online?.chat===data._id&&online.istyping)&&<Circle style={{fontSize:"13px",color:"green"}}/>}
              </div>
              {newLattestMessageExist?.length>0&&<div className='chat-left-allChat-each-right-lattestMessage'>
                {newLattestMessageExist[0]?.image?"Photo":lattest||"audio file"}
              </div>}

            </div>
         </div>
      </Link>    
  )

}

const AllShopes=({userData,HandleShowAllShopes,ActiveShope,optimizer,handle_optimizer})=>{
  let [AllShopes,GetAllShopes]=useState([])
  let [searchValue,handleSearchValue]=useState("")

  useEffect(()=>{
    axios.get(`${process.env.REACT_APP_URL}/api/shope/getAllShopes_dukana`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      GetAllShopes(res.data)
    })
    .catch(error=>{
    })

  },[])
  
  let filteredShopes=AllShopes?.filter(e=>{
    return e?._id!==ActiveShope&&e?.shope_name?.includes(searchValue)
  })


  return(
    <motion.div 
    initial={{ opacity: 0, x: -100 }}
    animate={{ opacity: 1, x: -20 }}
    transition={{ duration: 0.2 }}
     className='chat-left-allShopes'>
         <div style={{textAlign:"end"}}><IconButton onClick={()=>HandleShowAllShopes(false)}><CloseIcon style={{color:"red"}}/></IconButton></div>
         <div className='chat-left-allShopes-search'><Input onChange={(e)=>handleSearchValue(e.target.value)} value={searchValue}/></div>
         <div className='chat-left-allShopes-show'>
             {filteredShopes?.length===0?
               <div style={{textAlign:"center",marginTop:"40px",opacity:"0.6"}}>No shop found</div>
              :
              <>
                {filteredShopes?.map((e,index)=>{
                  return <Shope data={e} HandleShowAllShopes={HandleShowAllShopes} key={index}  handle_optimizer={handle_optimizer} optimizer={optimizer}
                          ActiveShope={ActiveShope} userData={userData}/>
                })}
             </>
             }
         </div>
    </motion.div>
  )
}

const Shope=({data,userData,ActiveShope,optimizer,handle_optimizer,HandleShowAllShopes})=>{
   let [loading,GetLoading]=useState(false)
   let [error,GetError]=useState(false)
 
   let navigate=useNavigate()
   const creatChatAndRedirect=()=>{
     let datas={
      shopIds:[ActiveShope,data?._id],
      name:"individual",
     }

    GetLoading(true)
    GetError(false)
    axios.post(`${process.env.REACT_APP_URL}/api/chats/CreatChat/`,datas, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      GetLoading(false)
      GetError(false)
      handle_optimizer(optimizer+1)
      HandleShowAllShopes(false)
      navigate(res.data._id)
    })
    .catch(error=>{
      GetLoading(false)
      GetError(true)
      //console.log(error);
    })


  }

  return(
    <div  onClick={creatChatAndRedirect} className='chat-left-allShopes-single'>
        <div><IconButton><MessageIcon style={{fontSize:"15px",color:error&&"red"}}/></IconButton></div>
        <div>{loading?<CircularProgress size={13}/>:data?.shope_name} </div>
    </div>
  )
}